import React, { useState } from 'react'
import style from './MobNav.module.scss'
import { FaGlobe } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

export default function MobNav() {
    const [isOpen, setisOpen] = useState(false);
    const [isLangOpen, setIsLangOpen] = useState(false);
    const { i18n, t } = useTranslation();
    
    const toggle = () => {
        setisOpen(!isOpen);
    };

    const handleLinkClick = () => {
        setisOpen(false);
    };

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
        document.dir = lng === 'ar' ? 'rtl' : 'ltr';
        setIsLangOpen(false);
    };

    return (
        <>
            <div className={`${style.mobNav}`}>
                <div className={`${style.mobLeft}`}>
                    <div className={`${style.logo}`}>
                        <img src="images/logo.png" alt={t('navbar.logo')} />
                    </div>
                </div>
                <div className={`${style.mobRight}`}>
                    <div className={`${style.icon}`}>
                        <i className="fa-solid fa-bars" onClick={toggle}></i>
                    </div>
                </div>
            </div>

            <div
                className={`${style.mobBar}`}
                style={{
                    height: isOpen ? "100%" : "0px",
                    padding: isOpen ? "10px 20px" : "0px 20px",
                    transition: "all 0.3s ease",
                }}
            >
                <div
                    className={`${style.head}`}
                    style={{
                        display: isOpen ? "flex" : "none",
                        transition: "all 0.3s ease",
                    }}
                >
                    <div className={`${style.logo}`}>
                        <img src="images/logoLight.png" alt={t('navbar.logo')} />
                    </div>
                    <div className={`${style.center}`}>
                    </div>
                    <div className={`${style.icon}`}>
                        <i className="fa-solid fa-xmark" onClick={toggle}></i>
                    </div>
                </div>

                <div
                    className={`${style.body}`}
                    style={{
                        display: isOpen ? "block" : "none",
                        transition: "all 0.3s ease",
                    }}
                >
                    <div className={`${style.item}`}>
                        <a href="#" className={`${style.links} nav-link`} onClick={handleLinkClick}>
                            {t('navbar.home')}
                        </a>
                    </div>
                    <div className={`${style.item}`}>
                        <a href="#about" className={`${style.links} nav-link`} onClick={handleLinkClick}>
                            {t('navbar.about')}
                        </a>
                    </div>
                    <div className={`${style.item}`}>
                        <a href="#services" className={`${style.links} nav-link`} onClick={handleLinkClick}>
                            {t('navbar.services')}
                        </a>
                    </div>
                    <div className={`${style.item}`}>
                        <a href="#product" className={`${style.links} nav-link`} onClick={handleLinkClick}>
                            {t('navbar.products')}
                        </a>
                    </div>
                    <div className={`${style.item}`}>
                        <a href="#contact" className={`${style.links} nav-link`} onClick={handleLinkClick}>
                            {t('navbar.contact')}
                        </a>
                    </div>
                    <div className={`${style.item} ${style.languageItem}`}>
                        <div className={`${style.languageSwitcher} ${style.center}`}>
                            <button className={`${style.languageButton}`} onClick={() => setIsLangOpen(!isLangOpen)}>
                                <FaGlobe />
                                <span>{i18n.language === 'ar' ? t('navbar.languages.arabic') : t('navbar.languages.english')}</span>
                            </button>
                            {isLangOpen && (
                                <div className={`${style.languageDropdown}`}>
                                    <button onClick={() => changeLanguage('en')}>
                                        {t('navbar.languages.english')}
                                    </button>
                                    <button onClick={() => changeLanguage('ar')}>
                                        {t('navbar.languages.arabic')}
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
